import { ALL_LNGS_NAMESPACES } from '@ingenico/util-i18n-config';
import { CoreButton } from '@ingenico/react-ui/core-button';
import { CoreTypography, CoreTypographyVariant } from '@ingenico/react-ui/core-typography';
import AddIcon from '@mui/icons-material/Add';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { DeviceAppVersionUploadSummaryProps } from './deviceAppVersionUploadSummary.model';
import styles from './deviceAppVersionUploadSummary.module.scss';

export function DeviceAppVersionUploadSummary({
  onAdd,
  hideAddButton,
  addButtonDisabled,
  size,
  hideSize,
}: DeviceAppVersionUploadSummaryProps): ReactNode {
  const { t } = useTranslation([ALL_LNGS_NAMESPACES.APPLICATION, ALL_LNGS_NAMESPACES.COMMON]);

  return (
    <div className={styles.container}>
      {hideSize ? undefined : (
        <div className={styles.labelWrapper}>
          <CoreTypography variant={CoreTypographyVariant.Body03Regular}>{`${t('title.size')}: ${size}`}</CoreTypography>
        </div>
      )}
      {!hideAddButton && (
        <CoreButton disabled={addButtonDisabled} onClick={onAdd} startIcon={<AddIcon />} variant="text">
          {t('common:button.add')}
        </CoreButton>
      )}
    </div>
  );
}
